var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages, select } from './messages';
import { UploadInput } from './UploadInput';
/** @hidden */
var defaultSelectMessageUI = function (props) { return React.createElement("span", null, props.message); };
/**
 * @hidden
 */
var UploadAddButton = /** @class */ (function (_super) {
    __extends(UploadAddButton, _super);
    function UploadAddButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focus = function () {
            if (_this._element) {
                _this._element.focus();
            }
        };
        _this.onClick = function () {
            _this.props.onClick.call(undefined, _this.props.addButtonIndex);
        };
        _this.onInputMouseDown = function (e) {
            if (_this._element) {
                e.preventDefault();
                _this._element.focus();
            }
        };
        return _this;
    }
    Object.defineProperty(UploadAddButton.prototype, "actionElement", {
        get: function () {
            if (this._uploadInput) {
                return this._uploadInput.actionElement;
            }
        },
        enumerable: true,
        configurable: true
    });
    UploadAddButton.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, navigationIndex = _a.navigationIndex, addButtonIndex = _a.addButtonIndex, notFocusedIndex = _a.notFocusedIndex;
        if (navigationIndex !== prevProps.navigationIndex &&
            prevProps.navigationIndex !== notFocusedIndex &&
            navigationIndex === addButtonIndex &&
            this._element) {
            this._element.focus();
        }
    };
    UploadAddButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, navigationIndex = _a.navigationIndex, addButtonIndex = _a.addButtonIndex, tabIndex = _a.tabIndex, id = _a.id, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, selectMessageUI = _a.selectMessageUI, others = __rest(_a, ["navigationIndex", "addButtonIndex", "tabIndex", "id", "ariaLabelledBy", "ariaDescribedBy", "selectMessageUI"]);
        var localizationService = provideLocalizationService(this);
        var selectMessage = localizationService.toLanguageString(select, messages[select]);
        var buttonClassName = classNames('k-button k-button-md k-rounded-md k-button-solid k-button-solid-base', 'k-upload-button', navigationIndex === addButtonIndex ? 'k-state-focused' : '');
        var SelectMessageUI = selectMessageUI ? selectMessageUI : defaultSelectMessageUI;
        return (React.createElement("div", { id: id, ref: function (ref) { return _this._element = ref; }, role: "button", className: buttonClassName, "aria-label": selectMessage, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, tabIndex: tabIndex, onClick: this.onClick },
            React.createElement(UploadInput, __assign({}, others, { onMouseDown: this.onInputMouseDown, ref: function (ref) { return _this._uploadInput = ref; } })),
            React.createElement(SelectMessageUI, { message: selectMessage })));
    };
    return UploadAddButton;
}(React.Component));
export { UploadAddButton };
registerForLocalization(UploadAddButton);
